import script from "./DatabaseAdministratorView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseAdministratorView.vue?vue&type=script&setup=true&lang=js"

import "./DatabaseAdministratorView.vue?vue&type=style&index=0&id=1460df2f&lang=scss"

const __exports__ = script;

export default __exports__